    /**
 * Product Tabs Section JavaScript
 * Manages Tab navigation, Mobile accordion state, and Color swatch switching.
 */

function initProductTabs(container) {
  const sections = container ? [container] : document.querySelectorAll('.product-tabs-section');

  sections.forEach(section => {
    // Tab & Mobile Accordion Switching Logic
    const tabButtons = section.querySelectorAll('.product-tabs__tab-btn');
    const accordionButtons = section.querySelectorAll('.product-tabs__accordion-btn');
    const tabPanels = section.querySelectorAll('.product-tabs__panel');

    function activateTab(targetTab) {
      tabButtons.forEach(b => {
        const isMatch = b.getAttribute('data-tab') === targetTab;
        b.classList.toggle('is-active', isMatch);
        b.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      });

      accordionButtons.forEach(ab => {
        const isMatch = ab.getAttribute('data-accordion-target') === targetTab;
        ab.classList.toggle('is-active', isMatch);
        ab.setAttribute('aria-expanded', isMatch ? 'true' : 'false');
      });

      tabPanels.forEach(p => {
        const isMatch = p.getAttribute('data-tab-panel') === targetTab;
        p.classList.toggle('is-active', isMatch);
      });
    }

    tabButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const targetTab = this.getAttribute('data-tab');
        activateTab(targetTab);
      });
    });

    accordionButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const targetTab = this.getAttribute('data-accordion-target');
        const isActive = this.classList.contains('is-active');

        if (isActive) {
          // Close active accordion item
          tabButtons.forEach(b => b.classList.remove('is-active'));
          accordionButtons.forEach(ab => {
            ab.classList.remove('is-active');
            ab.setAttribute('aria-expanded', 'false');
          });
          tabPanels.forEach(p => p.classList.remove('is-active'));
        } else {
          // Open target accordion item (only 1 open at a time)
          activateTab(targetTab);
        }
      });
    });

    // Swatch Click Logic for Description Tab
    const swatches = section.querySelectorAll('.js-color-swatch');
    const mainImg = section.querySelector('.product-tab-description__image');
    const mainBadge = section.querySelector('.product-tab-description__badge');

    swatches.forEach(swatch => {
      swatch.addEventListener('click', function() {
        swatches.forEach(s => s.classList.remove('is-active'));
        this.classList.add('is-active');

        const newImgSrc = this.getAttribute('data-image-src');
        const newImgAlt = this.getAttribute('data-image-alt');
        const newColorName = this.getAttribute('data-color-name');

        if (mainImg && newImgSrc) {
          mainImg.style.opacity = '0.3';
          setTimeout(() => {
            mainImg.src = newImgSrc;
            if (newImgAlt) mainImg.alt = newImgAlt;
            mainImg.style.opacity = '1';
          }, 150);
        }

        if (mainBadge && newColorName) {
          mainBadge.textContent = newColorName;
        }
      });
    });
   // Single Open Accordion Logic for FAQ items
    const faqDetails = section.querySelectorAll('.product-tab-info__accordion details');
    faqDetails.forEach(detail => {
      detail.addEventListener('toggle', function() {
        if (this.open) {
          faqDetails.forEach(other => {
            if (other !== this && other.open) {
              other.open = false;
            }
          });
        }
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initProductTabs());
} else {
  initProductTabs();
}

document.addEventListener('shopify:section:load', function(e) {
  if (e.target.classList.contains('section-product-tabs')) {
    initProductTabs(e.target);
  }
});
